/**
 * Analytics Middleware
 * This middleware will automatically send Analytic Events if the given action has a meta.tracking object on it
 * This is useful because it puts as much of the trcking into one place as possible
 * By default, only
 * 		Pageview
 * 		Events
 * 		Timing
 * 	can be tracked via this middleware
 * 		If you need additional tracking functionality, you'll have to either modify this, or directly track it
 *
 * In order for all actions to be captured, the Analytics Middleware must be last in the list
 * 	If it's not possible for the Analytics Middleware to be last
 * 	Then must be after all additional middleware that sends out modified actions
 * 		eg. After AJAXMiddleware
 */

import Tracking from "utils/Tracking";

function AnalyticsMiddleware(store){
	return function(next){
		return function(action){
			var track = null;

			if(!action.meta && !/LOCATION_CHANGE/gi.test(action.type)) { return next(action); }

			if(action.meta && action.meta.track) {
				let bld = "font-weight:bold; text-decoration:underline"
					, nml = "font-weight:normal;";

				console.warn(`You've passed in a %c\`track\`%c property on the Redux Action.  Automatic Analytics hooks expects %c\`tracking\`%c.\nTrack Object:\t`, bld, nml, bld, nml, action.meta.track);

				return next(action);
			}

			if(action.meta && action.meta.tracking) {
				track = action.meta.tracking;
			}

			/**
			 * Automatically track a location change as a new pageview
			 *
			 * TODO: Add in the proper title?
			 */

			if(/LOCATION_CHANGE/gi.test(action.type)) {
				track = {
					hitType:  "pageview",
					location: action.payload.location.pathname,
					// title:"",
				};
			}

			/* eslint-disable new-cap */
			if(track) {
				if(/page|view/.test(track.hitType)) {
					Tracking.TrackPage(track);
				} else if(/time|timing/.test(track.hitType)) {
					Tracking.TrackTime(track);
				} else {
					Tracking.TrackEvent(track);
				}
			}
			/* eslint-enable new-cap */

			return next(action);
		};
	};
}

export default AnalyticsMiddleware;
